import { render, staticRenderFns } from "./activitiesBanner.vue?vue&type=template&id=21c208ca&scoped=true"
import script from "./activitiesBanner.vue?vue&type=script&lang=js"
export * from "./activitiesBanner.vue?vue&type=script&lang=js"
import style0 from "./activitiesBanner.vue?vue&type=style&index=0&id=21c208ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c208ca",
  null
  
)

export default component.exports